import { render } from "./VendedoresList.vue?vue&type=template&id=3cb43244&scoped=true"
import script from "./VendedoresList.vue?vue&type=script&lang=js"
export * from "./VendedoresList.vue?vue&type=script&lang=js"

import "./VendedoresList.vue?vue&type=style&index=0&id=3cb43244&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cb43244"]])

export default __exports__